import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=b3655066&scoped=true&"
import script from "./Columns.vue?vue&type=script&lang=js&"
export * from "./Columns.vue?vue&type=script&lang=js&"
import style0 from "./Columns.vue?vue&type=style&index=0&id=b3655066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3655066",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})
